import { render, staticRenderFns } from "./StandardPage.vue?vue&type=template&id=b95b1cae&"
import script from "./StandardPage.vue?vue&type=script&lang=js&"
export * from "./StandardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports